export const UI_ICON_SIZE = '1.25rem'; // 20px — MUI fontSize="small"

// Shared MUI component defaults and overrides, applied to both themes.
//
// Icon sizing: resize only DEFAULT (medium) icons to 20px. Keyed on ownerState.fontSize so we
// leave alone:
//   - fontSize="small"   → already 20px
//   - fontSize="large"   → stays large (decorative)
//   - fontSize="inherit" → stays text-scaled (chat/session inline icons)
//   - any sx={{ fontSize }} → CSS wins over theme (dashboard 2rem, integration 1.5rem)
//
// This single override covers buttons, icon buttons, nav, dropdown menus, tabs, chips,
// and form controls — every per-component slot override would be redundant once the
// default icon size is 20px.
export const componentOverrides = {
  // Shadows are globally `none`, so an elevation Card is borderless; outlined
  // is what most call sites already ask for. A Card that is only an invisible
  // wrapper (around a framed Section, say) passes variant="elevation".
  MuiCard: {
    defaultProps: { variant: 'outlined' as const },
  },
  // Pass size="medium" for the few that are deliberately larger (avatar chips
  // in the headers, the floating teach-dock pill).
  MuiChip: {
    defaultProps: { size: 'small' as const },
  },
  MuiSvgIcon: {
    styleOverrides: {
      root: ({ ownerState }: { ownerState: { fontSize?: string } }) => ({
        ...(ownerState.fontSize === 'medium' && { fontSize: UI_ICON_SIZE }),
      }),
    },
  },
};
